/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { useCurrentEditor } from "@tiptap/react";
import { isValidGuid } from "utils/empty-exists";
import LinkSelector from "cms/links/link-selector";
import { useUpdateLink } from "cms/rich-text/simplicity-composer-tiptap/tiptap-extensions/simplicity-link/use-update-link";
import { LinkDisplay } from "cms/rich-text/simplicity-composer-tiptap/tiptap-extensions/simplicity-link/link-display";

const LinkSettingsDialog = () => {
    
    const { link, updateLink } = useUpdateLink();
    const { editor } = useCurrentEditor();
    
    const setLink = () => {};
    
    const onSelectLink = (link) => {
        updateLink(link);
    };
    
    const onRemoveLink = () => {
        editor.chain().focus().extendMarkRange("link").unsetLink().run();
        // editor.commands.setNode("paragraph", {})
    };
    
    const handleClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        const guid = link?.guid;
        if (!isValidGuid(guid)) {
            // const selection = editor.view.state.selection.to
            // editor.chain().focus().extendMarkRange('link').setNodeSelection( selection ).run();
            editor.chain().focus().extendMarkRange("link").unsetLink().run();
            editor.commands.setNode("paragraph", {});
            editor.chain().focus().selectTextblockEnd( ).run();
        }
    };
    
    return (
        <Fragment>
            <LinkSelector
                link={link}
                setLink={setLink}
                onSelectLink={onSelectLink}
                onLinkRemoved={onRemoveLink}
                // The buttons in the bubble menu are found inside LinkDisplay
                // these need to be callable from the within the LinkSelector
                DisplayComponent={LinkDisplay}
                AddComponent={LinkDisplay}
                handleCancel={handleClose}
            />
        </Fragment>
    );
};

export { LinkSettingsDialog };
